
    import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component
    export default class FadeTooltip extends Vue {
        @Prop()
        public tooltipText: string;
    };
